import React from 'react';

const Header = () => {
    // a header that renders the Title of the game
    
    return (
        <div className='header header-container'>
            Dudo Perudo
        </div>
    );
};

export default Header;
